import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

// Schlanke, controlled Tab-Leiste (KISS — kein Radix). Aktiver Tab via `value`,
// Wechsel via `onChange`. Der Aufrufer rendert den Inhalt selbst (conditional),
// die Leiste hält keinen eigenen State → URL-Deeplink bleibt beim Aufrufer.
export interface TabDef {
  value: string;
  label: string;
  icon?: ReactNode;
}

export function TabBar({
  tabs,
  value,
  onChange,
}: {
  tabs: TabDef[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="flex flex-wrap gap-1 border-b border-border" role="tablist">
      {tabs.map((t) => {
        const active = t.value === value;
        return (
          <button
            key={t.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(t.value)}
            data-testid={`tab-${t.value}`}
            className={cn(
              "-mb-px inline-flex items-center gap-1.5 border-b-2 px-3.5 py-2 text-[13px] font-semibold transition-colors",
              active
                ? "border-accent text-text"
                : "border-transparent text-text3 hover:border-border-strong hover:text-text",
            )}
          >
            {t.icon}
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
